var exports = {
  "Y": "xfd349460--00f54c--tooltip",
};

module.exports = exports;
